        const HOME = () => {
            return (
                <main>
                    <p><img src="023D/1009%20AM.jpg" /></p>
                </main>
            )
        }

        export default HOME;
